var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"dense":"","hint":"Cambie el tema de la aplicación","label":"Tema obscuro","persistent-hint":""},model:{value:(_vm.pscThemeDark),callback:function ($$v) {_vm.pscThemeDark=$$v},expression:"pscThemeDark"}})}
var staticRenderFns = []

export { render, staticRenderFns }